import { AppContext } from '@osos/shared/types';

export namespace AppStateActions {
  export class AppContextChanged {
    static readonly type = '[AppState] App Context Changed';
    /**
     *
     */
    constructor(public appContext: AppContext) {}
  }

  export class LoadUserRelatedData {
    static readonly type = '[AppState] Load User Related Data';
    /**
     * Load current user related data, such as data views and generic views.
     */
  }

  export class LoadAnonymousRelatedData {
    static readonly type = '[AppState] Load Anonymous Related Data ';
  }

  export class SetAccessId {
    static readonly type = '[AppState] Set Access ID';
    constructor(public accessId: string) {}
  }
  export class SetHeadlessModeConfig {
    static readonly type = '[AppState] Set Headless Mode config';
    constructor(
      public enabled: boolean,
      public config: {
        language: string;
        timeZoneOffset: number;
        userId: string;
      },
    ) {}
  }
  export class SetDefaultLanguageConfig {
    static readonly type = '[AppState] Set Default Language config';
    constructor(public language: string) {}
  }
}
